/*
 * Bike Clinique Upgrade Quote Planner — conversion events
 * Source brief: 2026-07-10-skool-landing-page-ai-cro-leak-gate.md
 * Privacy: sends event names, page path and funnel identifier only.
 * Never sends the rider's free text or personal details.
 */
(function () {
  'use strict';

  if (window.__bcUpgradePlannerEventsInstalled) return;
  window.__bcUpgradePlannerEventsInstalled = true;
  window.dataLayer = window.dataLayer || [];

  function pushEvent(eventName) {
    window.dataLayer.push({
      event: eventName,
      page_path: window.location.pathname,
      funnel: 'bike_upgrade_quote_planner'
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target.closest('button, a');
    if (!target) return;

    if (target.id === 'bc-calc') {
      pushEvent('upgrade_quote_generated');
      return;
    }

    if (!target.closest('#bc-output')) return;

    var label = (target.textContent || '').trim().toLowerCase();
    var href = target.getAttribute('href') || '';

    if (label.indexOf('book through the workshop') !== -1) {
      pushEvent('upgrade_booking_clicked');
    } else if (href.indexOf('mailto:') === 0) {
      pushEvent('upgrade_email_clicked');
    } else if (target.id === 'bc-copy-enquiry') {
      pushEvent('upgrade_enquiry_copied');
    }
  });
})();
